export enum ROLE_ENUM{

    HOST = 'HOST',
    GUEST = 'GUEST'
}